import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgPaperclipIconSecondary(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M12.52 2.75c-.41 0-.75.34-.75.75v7.3c0 3.35-2.17 3.71-3.1 3.71-1.53 0-3.17-.91-3.17-3.46V3.49c0-.74.36-1.99 1.71-1.99s2.13.57 2.13 3.51v5.82c0 .45-.09 1.2-.68 1.2-.17 0-.71 0-.71-1.07V3.4c0-.41-.34-.75-.75-.75s-.74.34-.74.75v7.56c0 1.9 1.19 2.57 2.21 2.57 1.08 0 2.18-.84 2.18-2.7V5.01c0-1.37 0-5.01-3.63-5.01C5.1 0 4 1.75 4 3.49v7.55C4 14.46 6.34 16 8.67 16c2.12 0 4.6-1.36 4.6-5.21V3.5c0-.42-.34-.75-.75-.75Z",
    fill: "currentColor"
  }));
}

export { SvgPaperclipIconSecondary as default };
